<template>
  <transition :name="transitionName">
    <div
      v-if="isVisible"
      ref="modal"
      class="modal"
    >
      <!--      <div class="modal-wrapper">-->
      <!--        <div class="modal-center">-->
      <div
        class="modal-backdrop"
        @click="close"
      />
      <div
        ref="modal-content"
        class="modal-container c-bg-white"
        :style="style"
      >
        <header
          v-if="$slots.header"
          class="modal-header py25 px65 h1 weight-700 bg-cl-secondary"
        >
          <slot name="header" />
          <i
            slot="close"
            class="icon icon-close-new"
            data-testid="closeModalButton"
            @click="close"
          />
        </header>
        <div
          v-if="$slots.content"
          class="modal-content c-bg-white pt30 pb60 px65"
        >
          <slot name="content" />
        </div>
        <slot />
      </div>
    </div>
    <!--      </div>-->
    <!--    </div>-->
  </transition>
</template>

<script>
import { mapMutations } from 'vuex'
import onEscapePress from '@vue-storefront/core/mixins/onEscapePress'
import ScrollLock from 'theme/mixins/scrollLock'

export default {
  name: 'Modal',
  mixins: [onEscapePress, ScrollLock],
  props: {
    name: {
      required: true,
      type: String
    },
    delay: {
      required: false,
      type: Number,
      default: 300
    },
    width: {
      type: Number,
      default: 0
    },
    transitionName: {
      type: String,
      default: 'fade-in-down'
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  computed: {
    style () {
      return this.width ? `width: ${this.width}px` : false
    }
  },
  watch: {
    isVisible (state) {
      if (state) {
        this.$nextTick(() => {
          this.disableBodyScroll()
        })
      } else {
        this.clearAllBodyScrollLocks()
      }
    }
  },
  beforeMount () {
    this.$bus.$on('modal-toggle', this.onToggle)
    this.$bus.$on('modal-show', this.onShow)
    this.$bus.$on('modal-hide', this.onHide)
  },
  beforeDestroy () {
    this.$bus.$off('modal-toggle', this.onToggle)
    this.$bus.$off('modal-show', this.onShow)
    this.$bus.$off('modal-hide', this.onHide)
  },
  methods: {
    onHide (name, state, params) {
      return name === this.name ? this.toggle(false) : false
    },
    onShow (name, state, params) {
      return name === this.name ? this.toggle(true) : false
    },
    onToggle (name, state, params) {
      if (name === this.name) {
        state = typeof state === 'undefined' ? !this.isVisible : state
        this.toggle(state)
      }
    },
    onEscapePress () {
      this.close()
    },
    ...mapMutations('ui', [
      'setOverlay'
    ]),
    toggle (state) {
      this.isVisible = state
      state ? this.setOverlay(state) : setTimeout(() => this.setOverlay(state), this.delay)
    },
    close () {
      this.toggle(false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
$z-index-modal: map-get($z-index, modal);

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: $z-index-modal;

  .modal-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 945px;
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
    z-index: $z-index-modal+1;
    border-radius: 20px;
    overflow: hidden;
    padding: 35px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media (max-width: 600px) {
      min-height: 100%;
      min-width: 100%;
      margin: 0;
      border-radius: 0;
      padding: 0;
      max-height: 100vh;
    }
  }

  .modal-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > * {
      margin: 0;
    }

    @media (max-width: 600px) {
      padding: 15px 20px;
    }
  }

  .modal-content {
    @media (max-width: 600px) {
      padding: 30px 20px;
      padding-top: 0;
    }
  }

  .modal-close {
    cursor: pointer;
  }

  .modal-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .icon-close-new {
    width: 24px;
    height: 24px;

    @media (max-width: 600px) {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
